import { render, staticRenderFns } from "./BaseAppFooter.vue?vue&type=template&id=51a2d8d8&scoped=true"
import script from "./BaseAppFooter.vue?vue&type=script&lang=js"
export * from "./BaseAppFooter.vue?vue&type=script&lang=js"
import style0 from "./BaseAppFooter.vue?vue&type=style&index=0&id=51a2d8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a2d8d8",
  null
  
)

export default component.exports